module.exports = __webpack_public_path__ + "static/img/zgwy.665d6b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/zgwy.png
// module id = HmZl
// module chunks = 44